import NoticeListTable from "./components/noticesTable";
import NoticeToolBar from "./components/noticesToolbar";

export default function NoticeList() {
  return (
    <>
      <NoticeToolBar />
      <NoticeListTable />
    </>
  );
}
